import useTranslate from 'modules/local/useTranslate'
import React, {useCallback} from 'react'
import {NullAsDefault} from 'views/Shared'
import _ from 'lodash'
import {SelectCountries} from '../../../Organization/Settings/SelectCountries'
import {useAppConfig} from '../../../../modules/local/AppConfigContext'
import {FilterStatusBar} from '../../../../components/Filters/FilterStatusBar'
import {TargetGenderTypes} from '../../ReligiousOrder/components/ReligiousOrderForm'
import {AuthorityTypeInfos} from '../../ReligiousOrder/consts/AuthorityTypes'
import {NatureTypeInfos, NatureTypes} from '../../ReligiousOrder/consts/NatureTypes'
import {Chip, SectionLabel} from './DirectoryFilterUI'

// Tab mặc định chỉ hiện đúng Dòng tu (nature_typecd='religious_order' qua defaultFilterValues của
// directoryTypes) - chip Bản chất ở đây dùng để MỞ RỘNG xem thêm Tu Hội Đời/Tu Đoàn Tông Đồ/CGTH,
// bỏ chọn hết (không còn chip nào active) nghĩa là hiện gộp cả 4 loại.
const defaultFilter = {
    keyword: undefined,
    nature_typecd: undefined,
    target_gender: undefined,
    authority_typecd: undefined,
    country_id: undefined,
}

export const DirectoryReligiousOrderFilter = ({
                                                   value: filter = defaultFilter,
                                                   onChange: setValues = NullAsDefault,
                                               }) => {
    const t = useTranslate()
    const {countries = []} = useAppConfig('countries')

    const handleChange = useCallback(
        (name, value) => setValues({...filter, [name]: value}),
        [filter]
    )

    // filterState ban đầu rỗng (để không ăn gian hasSearched) nhưng data thực tế đã lọc theo
    // religious_order qua defaultFilterValues của directoryTypes - fallback ở đây để chip hiển thị
    // đúng trạng thái đang active, khớp với data đang hiện trên danh sách.
    const activeNatureType = filter?.nature_typecd ?? NatureTypes.RELIGIOUS_ORDER

    const filteredParams = Object.entries(filter)
        .filter(([, value]) => value != null)
        .map(([key, value]) => {
            switch (key) {
                case 'country_id':
                    return {key, value, displayValue: _.find(countries, {id: Number(value)})?.common_name}
                case 'authority_typecd':
                    return {key, value, displayValue: t(_.find(AuthorityTypeInfos, {value})?.label)}
                case 'nature_typecd':
                    return {key, value, displayValue: t(_.find(NatureTypeInfos, {value})?.label)}
                case 'target_gender':
                    return {key, value, displayValue: t(_.find(TargetGenderTypes, {value: Number(value)})?.label)}
                default:
                    return {key, value, displayValue: value}
            }
        })

    return (
        <div className="flex flex-col gap-3">
            <FilterStatusBar
                filteredParams={filteredParams}
                onClear={() => setValues(defaultFilter)}
                onRemove={(param) => handleChange(param, undefined)}
            />

            <div className="flex flex-col gap-1">
                <SectionLabel>{t('nature type')}</SectionLabel>
                <div className="flex flex-wrap gap-1.5">
                    {Object.values(NatureTypeInfos).map((e) => (
                        <Chip
                            key={e.value}
                            active={activeNatureType === e.value}
                            onClick={() => handleChange('nature_typecd', activeNatureType === e.value ? undefined : e.value)}>
                            {t(e.label)}
                        </Chip>
                    ))}
                </div>
            </div>

            <div className="flex flex-col gap-1">
                <SectionLabel>{t('authority type')}</SectionLabel>
                <div className="flex flex-wrap gap-1.5">
                    {Object.values(AuthorityTypeInfos).map((e) => (
                        <Chip
                            key={e.value}
                            active={filter?.authority_typecd === e.value}
                            onClick={() => handleChange('authority_typecd', filter?.authority_typecd === e.value ? undefined : e.value)}>
                            {t(e.label)}
                        </Chip>
                    ))}
                </div>
            </div>

            <div className="flex flex-col gap-1">
                <SectionLabel>{t('target gender')}</SectionLabel>
                <div className="flex flex-wrap gap-1.5">
                    {Object.values(TargetGenderTypes).map((e) => (
                        <Chip
                            key={e.value}
                            active={Number(filter?.target_gender) === e.value}
                            onClick={() => handleChange('target_gender', Number(filter?.target_gender) === e.value ? undefined : e.value)}>
                            {t(e.label)}
                        </Chip>
                    ))}
                </div>
            </div>

            <div className="flex flex-col gap-1">
                <SectionLabel>{t('country')}</SectionLabel>
                <SelectCountries
                    value={filter?.country_id || undefined}
                    allowClear={true}
                    onChange={(value) => handleChange('country_id', Number(value) || undefined)}
                    placeholder={t('click to select')}
                />
            </div>
        </div>
    )
}

export default DirectoryReligiousOrderFilter
